import { Routes as RouteDefinitions } from 'config/routes';
import isEmpty from 'lodash/isEmpty';

class LinkHandler {
  _routes = {};

  constructor() {
    const _routes = [];
    Object.keys(RouteDefinitions).forEach((routeKey, index) => {
      const route = RouteDefinitions[routeKey];
      _routes.push({
        key: routeKey,
        ...route,
        sorting: RouteDefinitions[routeKey]?.sorting || 100 + index
      });
    });
    this._routes = _routes
      .sort((a, b) => a.sorting - b.sorting)
      .reduce((acc, route) => {
        acc[route.key] = route;
        return acc;
      }, {});
  }

  get(routeKey, args = {}) {
    const route = this._routes[routeKey];
    if (!route) {
      return routeKey;
    }

    return this.getUrlWithArguments(route.path, args, route);
  }

  getRoute(routeKey) {
    return this._routes?.[routeKey] || null;
  }

  getAll() {
    return this._routes;
  }

  getUrlWithArguments(path, args = {}, route = null) {
    let _path = path || '';

    for (const key in args) {
      const value = args[key];
      if (_path.match(`:${key}`)) {
        _path = _path.replace(`:${key}?`, `:${key}`).replace(`:${key}`, `${value || ''}`);
      }
    }

    return _path;
  }
}

export const linkHandler = new LinkHandler();
